/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Order } from './Order'
import {
  OrderFromJSON,
  OrderFromJSONTyped,
  OrderToJSON,
  OrderToJSONTyped,
} from './Order'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'

/**
 *
 * @export
 * @interface ResponseOrderGetOne
 */
export interface ResponseOrderGetOne {
  /**
   *
   * @type {boolean}
   * @memberof ResponseOrderGetOne
   */
  success: boolean
  /**
   *
   * @type {Order}
   * @memberof ResponseOrderGetOne
   */
  data?: Order
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseOrderGetOne
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseOrderGetOne
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseOrderGetOne
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseOrderGetOne interface.
 */
export function instanceOfResponseOrderGetOne(
  value: object,
): value is ResponseOrderGetOne {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseOrderGetOneFromJSON(json: any): ResponseOrderGetOne {
  return ResponseOrderGetOneFromJSONTyped(json, false)
}

export function ResponseOrderGetOneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseOrderGetOne {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data: json['data'] == null ? undefined : OrderFromJSON(json['data']),
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseOrderGetOneToJSON(json: any): ResponseOrderGetOne {
  return ResponseOrderGetOneToJSONTyped(json, false)
}

export function ResponseOrderGetOneToJSONTyped(
  value?: ResponseOrderGetOne | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data: OrderToJSON(value['data']),
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
